export default __webpack_public_path__ + "static/media/banner.71b51d8c.png";